import TableCompo from '../../components/table/TableCompo';
import useCleanupOnRouteChange from '../../utilities/Cleanup';
import usePaginatedData from '../../utilities/Paginationdata';

const Driver = () => {

    const {
        data,
        prevData,
        page,
        setPage,
        isLoading,
        message,
        inputValue,
        handleSearch,
        filterValue,
        handleFilter,
    } = usePaginatedData({
        url: `${process.env.REACT_APP_URL}/api/drivers`,
        localKeys: {
            search: 'search-driver',
            filter: 'filter-driver',
            page: 'pageno-driver',
            totalPage: 'totalpage-driver',
            totalData: 'totaldata-driver',
        },
        enableSearch: true,
        enableFilter: true,
    });

    const filterOptions = [
        { value: 'verified', label: 'Verified', name: 'verification' },
        { value: 'notverified', label: 'Not verified', name: 'verification' },
        { value: 'online', label: 'Online', name: 'status' },
        { value: 'Ura premium', label: 'Ura Premium', name: 'medium' },
        { value: 'Ura Car', label: 'Ura Car', name: 'medium' },
        { value: 'Ura Bike', label: 'Ura Bike', name: 'medium' },
        { value: '1', label: 'Hidden Drivers', name: ' SoftDelete' },
        { value: 'referral_code', label: 'Captain Drivers', name: ' referral_code' },
    ];

    useCleanupOnRouteChange(
        ['search-driver', 'filter-driver', 'totalpage-driver', 'totaldata-driver', 'pageno-driver'],
        '/drivers');

    return (
        <TableCompo
            title="Driver"
            data={data}
            prevData={prevData}
            page={page}
            setPage={setPage}
            isLoading={isLoading}
            message={message}
            search={true}
            view={true}
            pagination={true}
            navPath={'details'}
            handleSearch={handleSearch}
            filter={true}
            filterval={handleFilter}
            fil={filterValue}
            filterOptions={filterOptions}
            inputValue={inputValue}
            serialNo={true}
            rowClickable={true}
            deleteBtn={true}

        />
    );

};

export default Driver;
